import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { MinimumStationsGroup } from '@app/core/types/stations';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/**
 * Local toolbar filters for the admin station-groups list (name search).
 */
export const ADMIN_STATION_GROUPS_FILTERS_CONFIG = [
  createFilter({
    name: 'name',
    label: defineMessage({
      id: 'common.text.name',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      placeholder: defineMessage({
        id: 'admin.stationGroups.filters.namePlaceholder',
        defaultMessage: 'Buscar por nombre',
      }),
      sx: {
        width: '22ch',
      },
    },
    filterFn: (item, value) => {
      const group = item as MinimumStationsGroup;
      const q = typeof value === 'string' ? value.trim().toLowerCase() : '';
      if (!q) {
        return true;
      }
      return group.name.toLowerCase().includes(q);
    },
  }),
];
